import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { InputAttribute } from 'app/private/sxfdesigner/types/designer-attribute-type';
import { DescOptions } from 'app/private/sxfdesigner/types/view-engine.interface';
import {
  INPUT_TYPE,
  VALUE,
} from 'app/infrastructure/model/constants/outputViewEngineConstants.constant';

@Component({
  selector: 'inputs-view-engine-tab',
  templateUrl: './inputs-view-engine.component.html',
})
export class InputsViewEngineComponent implements OnInit, OnDestroy {
  @Input() inputAtt: InputAttribute[];
  _objectInput: InputAttribute;
  inputTypes: Array<DescOptions>;
  objectKeys = Object.keys;

  ngOnInit() {
    this._objectInput = this.inputAtt[0];
    this.inputTypes = this._objectInput.inputTypes;
    this.setValue();
  }

  ngOnDestroy() {
    this._objectInput = <InputAttribute>{};
  }

  getValue(event, input) {
    this._objectInput.value[input][VALUE] = event.target.value;
  }

  onChangeOption(value, codigo) {
    this._objectInput.value[codigo] = {
      ...this._objectInput.value[codigo],
    };
    this._objectInput.value[codigo][INPUT_TYPE] = value;
    this._objectInput.value[codigo][VALUE] = '';
  }

  showInput(input) {
    return this._objectInput.value[input][INPUT_TYPE] != null;
  }

  private setValue() {
    for (let input in this._objectInput.value) {
      if (
        input === 'model' ||
        input === 'quotationResult' ||
        input === 'assetsrv' ||
        input === 'sxNotificationSrv' ||
        input === 'simpleQuery' ||
        input === 'interactionEventResponse' ||
        input === 'communicationService' ||
        input === 'sxPublicServices' ||
        input === 'sxPortfolioService' ||
        input === 'datasource' ||
        input === 'queryParams'
      ){
        delete this._objectInput.value[input];
      } else {
        const inputsValue = this._objectInput.value[input];
        if (inputsValue != null && inputsValue != '') {
          if (typeof inputsValue === 'string') {
            this._objectInput.value[input] = {};
            this._objectInput.value[input][INPUT_TYPE] = 'constant';
            this._objectInput.value[input][VALUE] = inputsValue;
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/view-engine/tabs/inputs/inputs-view-engine.component.ts